import React, {Component} from 'react';
import PropTypes from 'prop-types';

/**
 * Hover is a Div component that exposes an is_hovered prop.
 * Use this prop to capture 'on hover' events.
 */
export default class Hover extends Component {
    render() {
        const {id, style, className, title, children, setProps} = this.props;
        return (
            <div id={id}
                 style={style}
                 className={className}
                 title={title}
                 onMouseEnter={() => setProps({is_hovered: true})}
                 onMouseLeave={() => setProps({is_hovered: false})}>
                {children}
            </div>
        )
    }
}

Hover.defaultProps = {};

Hover.propTypes = {
    /**
     * The ID used to identify this component in Dash callbacks.
     */
    id: PropTypes.string,

    /**
     * True when the mouse is over this component, False otherwise.
     */
    is_hovered: PropTypes.bool,


    /**
     * Defines CSS styles which will override styles previously set.
     */
    style: PropTypes.any,

    /**
     * Often used with CSS to style elements with common properties.
     */
    className: PropTypes.string,

    /**
     * Text to be displayed in a tooltip when hovering over the element.
     */
    title: PropTypes.string,

    /**
     * The children of this component.
     */
    children: PropTypes.any,

    /**
     * Dash-assigned callback that should be called to report property changes
     * to Dash, to make them available for callbacks.
     */
    setProps: PropTypes.func
};

